import React from 'react';
import { useCountdown } from '../components/longevity/useCountdown';
import { UrgencyBar } from '../components/longevity/UrgencyBar';
import { Hero } from '../components/longevity/Hero';
import { Hook } from '../components/longevity/Hook';
import { PainAgitation } from '../components/longevity/PainAgitation';
import { Revelation } from '../components/longevity/Revelation';
import { SocialProof } from '../components/longevity/SocialProof';
import { Offer } from '../components/longevity/Offer';
import { PriceUrgency } from '../components/longevity/PriceUrgency';
import { FAQ } from '../components/longevity/FAQ';
import { Guarantee } from '../components/longevity/Guarantee';
import { Close } from '../components/longevity/Close';
import { Footer } from '../components/longevity/Footer';
import { SocialActivityTicker } from '../components/longevity/SocialActivityTicker';
export const Home: React.FC = () => {
  // 5 minutes and 42 seconds = 342 seconds
  const {
    formattedTime
  } = useCountdown(342);
  return <div className="min-h-screen bg-cream font-sans text-charcoal selection:bg-gold/30" data-id="element-296">
      <UrgencyBar formattedTime={formattedTime} data-id="element-297" />

      <main data-id="element-298">
        <Hero data-id="element-299" />
        <Hook data-id="element-300" />
        <PainAgitation data-id="element-301" />
        <Revelation data-id="element-302" />
        <SocialProof data-id="element-303" />
        <Offer data-id="element-304" />
        <PriceUrgency formattedTime={formattedTime} data-id="element-305" />
        <FAQ data-id="element-306" />
        <Guarantee data-id="element-307" />
        <Close data-id="element-308" />
      </main>

      <Footer data-id="element-309" />
      <SocialActivityTicker data-id="element-310" />
    </div>;
};